import { AfterViewInit, Component, OnInit, QueryList, ViewChildren, ViewEncapsulation, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { ActivityTabs } from 'src/app/shared/constants/commonenums';
import { DynamicFormComponent } from 'src/app/shared/dynamicform/dynamic-form/dynamic-form.component';
import { FieldConfig } from 'src/app/shared/dynamicform/models/common-models';
import { BookingActivity, LessonTypes } from 'src/app/shared/Models/SessionBookingDTO';
import { operationType } from 'src/app/shared/Models/WidgetSettingsModels';
import { GuestService } from 'src/app/shared/services/guest.service';

@Component({
    selector: 'app-activity-class-booking',
    templateUrl: './activity-class-booking.component.html',
    styleUrls: ['./activity-class-booking.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ActivityClassBookingComponent implements OnInit, AfterViewInit, OnDestroy {
  cols = [
    { field: 'LessonName', header: 'ActivityName', style: { 'width': '20%' },availability:true },
    { field: 'LocationName', header: 'Location', style: { 'width': '18%' },availability:true },
    { field: 'Staffs', header: 'Instructor', style: { 'width': '17%' },availability:true },
    { field: 'Availability', header: 'Availability', style: { 'width': '15%' },availability:true },
    { field: 'StartDate', header: 'startDate', style: { 'width': '10%' }, alignRight: true, isDate: true,availability:true },
    { field: 'EndDate', header: 'endDate', style: { 'width': '10%' }, alignRight: true, isDate: true,availability:true},
    { field: 'BaseRate', header: 'BasePrice', style: { 'width': '10%' }, alignRight: true, isCurrency: true ,availability:true },
  ];
  columnsToDisplay: any = [];
  filterDataGridList: MatTableDataSource<any>;
  isListView = false;
  search_config: FieldConfig[];
  availableActivities: any[];
  tempAvailableActivities: any[];
  lessonType = 0;
  Subscriptions: Subscription = new Subscription();
  @ViewChildren('form') components: QueryList<DynamicFormComponent>;

  constructor(public activityService: GuestService, public ts: TranslateService) {
    this.Subscriptions.add(this.activityService.allClassActivitiesAvailable$.subscribe(value => {
      this.availableActivities = value;
      this.tempAvailableActivities = value;
    }));
    this.Subscriptions.add(this.activityService.bookingSection$.subscribe(data => {
      if (data === BookingActivity.ClassBooking) {
        this.lessonType = LessonTypes.GroupLesson;
      } else if (data === BookingActivity.PrivateLesson) {
        this.lessonType = LessonTypes.PrivateLesson;
      }
      this.availableActivities = this.availableActivities.filter(x => x.LessonType === this.lessonType);
      this.tempAvailableActivities = this.tempAvailableActivities.filter(x => x.LessonType === this.lessonType);
    }));
  }

  ngOnInit(): void {
    if(this.lessonType == LessonTypes.PrivateLesson){
      this.cols[6].availability = false;
      this.cols[1].style = { 'width': '25%' }
      this.cols[2].style = { 'width': '24%' }
      this.cols[6].style = { 'width': '0%' };
    }
    this.columnsToDisplay = this.cols.map(x => {
      return x.field;
    })

    this.search_config = [
      {
        type: 'input',
        label: this.ts.instant("SearchbyActivityName"),
        name: 'SearchbyActivityName',
        inputType: 'text',
        class: 'guest-details__first-name',
        showErrorText: true,
        icon: 'icon-search',
        appearance: true,
        isFormArray: false,
        value: ''
      },
    ];

  }

  ngAfterViewInit() {
    this.components.first.form.valueChanges.subscribe(value => {
      if (this.isListView) {
        this.filterDataGridList.filter = value.SearchbyActivityName;
      } else {
        this.searchOperation(value.SearchbyActivityName);
      }
    })
  }

  changeView(value) {
    this.isListView = value;
    this.search_config[0].value = '';
    if (this.isListView) {
      this.filterDataGridList = new MatTableDataSource<any>(this.availableActivities);
    }
  }

  getInstructor(staffdata) {
    const staff = this.activityService.InstructorList.filter(data => data.Id === staffdata.ServerId)[0];
    if (staff) {
      return staff.Name + ' ' + (staff.LastName || '');
    }
    else {
      return '';
    }
  }


  loadClassActivities(data) {
    const ActivitiesList = [];
    data.forEach(lesson => {
      let locationval = [];
      let staffval = [];
      lesson.ActivitySessions.forEach(session => {
        if(session.SessionLocationMappings){
          session.SessionLocationMappings.forEach(location => {
            if ((locationval && locationval.length == 0) || locationval.length > 0 && !locationval.find(x => x.LocationId == location.StandaloneTableId))
              locationval.push({ 'LocationName': this.getLocation(location), 'LocationId': location.StandaloneTableId });
          });
        }
        if(session.SessionStaffMappings){
        session.SessionStaffMappings.forEach(staff => {
          if ((staffval && staffval.length == 0) || staffval.length > 0 && !staffval.find(x => x.ServerId == staff.ServerId))
            staffval.push({ 'ServerId': staff.ServerId, 'StaffName': this.getInstructor(staff) });
        });
      }
      });

      locationval = locationval.sort((a, b) => (a.LocationName > b.LocationName) ? 1 : ((b.LocationName > a.LocationName) ? -1 : 0))
      lesson['LocationName'] = locationval.map(function (elem) {
        return elem.LocationName;
      }).join(",");
      lesson['Staffs'] = staffval?.filter(x => x).map(function (elem) {
        return elem.StaffName;
      }).join(",");
      lesson['LessonName'] = lesson.Name;
      lesson['LocationId'] = locationval;
      lesson['StaffValues'] = staffval;
      lesson['SpecialMealId'] = lesson.Id;
      lesson['Availability'] = 'Available';
      ActivitiesList.push(lesson);
    });

    this.availableActivities = ActivitiesList;
    this.availableActivities = this.availableActivities.filter(x => x.LessonType === this.lessonType);
    if (this.isListView) {
      this.filterDataGridList = new MatTableDataSource<any>(this.availableActivities);
    }
  }

  selectedItem(data, index) {
    this.selectedClassActivity(this.availableActivities[index]);
  }

  getLocation(location) {
    return this.activityService.LocationList.filter(data => data.Id === location.StandaloneTableId)[0].Name || '';
  }

  selectedClassActivity(data) {
    if(data.Availability === 'Available'){
      this.activityService.operation = operationType.create;
      this.activityService.SelectedActivity$.next(data);
      this.activityService.TabChange$.next(ActivityTabs.ActvityView);
    }
  }

  searchOperation(value) {
    if (value.length >= 3) {
      value = value.toLowerCase();
      let searchData = _.filter(this.tempAvailableActivities, (data) => {
        let name = data.LessonName.toLowerCase();
        return name.includes(value)
      });
      this.availableActivities = searchData;
    } else {
      this.availableActivities = this.tempAvailableActivities;
    }
  }

  assignResetData(value) {
    if (value === true) {
      this.availableActivities = this.tempAvailableActivities;
    }
    if (this.isListView) {
      this.filterDataGridList = new MatTableDataSource<any>(this.availableActivities);
    }
  }

  ngOnDestroy(): void {
    if (this.Subscriptions) { this.Subscriptions.unsubscribe(); }
  }
}
